import requests from "./httpService";

/**
 * Global settings helpers.
 * Routes align with Laravel SIM-Back:
 * - GET  /admin/settings/
 * - POST /admin/settings/store
 * - PUT  /admin/settings/update/{id}
 * (Legacy template paths /setting/global/* do not exist and returned 404.)
 */
const SettingServices = {
  addGlobalSetting: async (body) => {
    return requests.post("/admin/settings/store", body);
  },

  getGlobalSetting: async () => {
    // Public Laravel route (no /setting/global/all in this API)
    const res = await requests.get("/user/settings/all_settings");
    const first = res?.data && !Array.isArray(res.data) ? res.data : (res?.data?.[0] || {});

    // Template pages expect fields like default_currency; Laravel Setting
    // model uses adresse/email/etc. Provide safe defaults so UI does not break.
    return {
      default_currency: "$",
      default_time_zone: "UTC",
      default_date_format: "YYYY-MM-DD",
      number_of_image_per_product: 5,
      ...first,
    };
  },

  updateGlobalSetting: async (body) => {
    const id = body?.id ?? body?.setting?.id;
    if (!id) {
      // Fallback: update first existing setting if id was not provided
      const current = await SettingServices.getGlobalSetting();
      if (current?.id) {
        return requests.put(`/admin/settings/update/${current.id}`, body);
      }
      return requests.post("/admin/settings/store", body);
    }
    return requests.put(`/admin/settings/update/${id}`, body);
  },
};

export default SettingServices;
